import { Box, Paper, Switch, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import AlertCircleIco from "../../../../../assets/icons/AlertCircleIco";
import HumanLocation from "../../../../../assets/icons/HumanLocationIco";
import StarIcon from "../../../../../assets/icons/StarIcon";
import CommonButton from "../../../../../component/Button";

const colors = {
  Low: "#FF4B57",
  Medium: "#F79009",
  High: "#17B26A",
};
const markers = [
  {
    name: "Karthik",
    coordinates: [-122.4194, 37.7749],
    status: "High",
    color: <HumanLocation color={colors} style={{ width: 20, height: 20 }} />,
  },
  {
    name: "Lana",
    coordinates: [-118.2437, 34.0522],
    color: <HumanLocation color={colors} style={{ width: 20, height: 20 }} />,
    status: "Medium",
  },
  {
    name: "Olivia",
    coordinates: [-99.784, 47.5665],
    color: <HumanLocation color={colors} style={{ width: 20, height: 20 }} />,
    status: "Medium",
  },
  {
    name: "Smith",
    coordinates: [-105.7821, 39.5501],
    color: <HumanLocation color={colors} style={{ width: 20, height: 20 }} />,
    status: "Low",
  },
  {
    coordinates: [-84.388, 33.749],
    city: "Atlanta",
    image: <StarIcon style={{ width: 16, height: 16, marginRight: 8 }} />,
  },
  {
    coordinates: [-90.1994, 35.1495],
    city: "Memphis",
    image: <StarIcon style={{ width: 16, height: 16, marginRight: 8 }} />,
  },
  {
    coordinates: [-87.6298, 41.8781],
    city: "Chicago",
    image: <StarIcon style={{ width: 16, height: 16, marginRight: 8 }} />,
  },
  {
    coordinates: [-71.0589, 42.3601],
    city: "Boston",
    image: <StarIcon style={{ width: 16, height: 16, marginRight: 8 }} />,
  },
  {
    coordinates: [-74.006, 40.7128],
    city: "New York City",
    image: <StarIcon style={{ width: 16, height: 16, marginRight: 8 }} />,
  },
  {
    coordinates: [-77.0369, 38.9072],
    city: "Washington State",
    image: <StarIcon style={{ width: 16, height: 16, marginRight: 8 }} />,
  },
  {
    coordinates: [-78.6382, 35.7796],
    city: "Raleigh-Durham",
    image: <StarIcon style={{ width: 16, height: 16, marginRight: 8 }} />,
  },
  {
    coordinates: [-95.3698, 29.7604],
    city: "Houston",
    image: <StarIcon style={{ width: 16, height: 16, marginRight: 8 }} />,
  },
  {
    coordinates: [-111.8835, 40.7608],
    city: "Salt Lake City",
    image: <StarIcon style={{ width: 16, height: 16, marginRight: 8 }} />,
  },
  {
    coordinates: [-120.7401, 47.4009],
    city: "Washington",
    image: <StarIcon style={{ width: 16, height: 16, marginRight: 8 }} />,
  },
  {
    coordinates: [-120.5542, 43.8041],
    city: "Oregon",
    image: <StarIcon style={{ width: 16, height: 16, marginRight: 8 }} />,
  },
];
const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";
const CandidateProximityInsight = () => {
  const [showHubCities, setShowHubCities] = useState(true);
  const legendContent = (
    <Box sx={{ padding: 2 }}>
      <Typography variant="subtitle1" gutterBottom>
        Distance
      </Typography>
      <Box display="flex" gap={1}>
        <Box display="flex" alignItems="center" gap={1}>
          <Box
            sx={{
              width: 16,
              height: 16,
              backgroundColor: colors.High,
              borderRadius: "50%",
            }}
          />
          <Typography>High</Typography>
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          <Box
            sx={{
              width: 16,
              height: 16,
              backgroundColor: colors.Medium,
              borderRadius: "50%",
            }}
          />
          <Typography>Medium</Typography>
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          <Box
            sx={{
              width: 16,
              height: 16,
              backgroundColor: colors.Low,
              borderRadius: "50%",
            }}
          />
          <Typography>Low</Typography>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ padding: 3 }} fontFamily={"Inter"}>
      <Paper
        sx={{
          padding: 2,
          marginBottom: 3,
          border: "1px solid #EAECEE",
          borderRadius: "10px",
          boxShadow: "unset",
        }}
      >
        <ComposableMap
          projection="geoAlbersUsa"
          projectionConfig={{ scale: 1000 }}
          style={{ width: "100%", height: "800" }}
          center={[-95.7129, 37.7749]}
        >
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map((geo) => (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  style={{
                    default: {
                      fill: "#E0E0E0",
                      stroke: "#FFFFFF",
                      strokeWidth: 0.75,
                    },
                    hover: { fill: "#D6D6D6" },
                    pressed: { fill: "#CFCFCF" },
                  }}
                />
              ))
            }
          </Geographies>
          {markers.map(({ name, coordinates, color, city, image, status }) => (
            <Marker key={coordinates.join(",")} coordinates={coordinates}>
              <g>
                {status && (
                  <g>
                    <HumanLocation
                      color={colors[status]}
                      style={{ width: 20, height: 20 }}
                    />
                  </g>
                )}
                {name && (
                  <g transform="translate(32, 0)">
                    <rect
                      x={0}
                      y={0}
                      width={name.length * 10 + 40}
                      height={32}
                      fill="white"
                      stroke="#DCDFE4"
                      strokeWidth={1}
                      rx={17}
                      ry={17}
                    />
                    <text
                      x={(name.length * 10 + 40) / 2}
                      y={32 / 2}
                      textAnchor="middle"
                      alignmentBaseline="middle"
                      style={{
                        fontSize: "12px",
                        fill: "#333",
                        pointerEvents: "none",
                      }}
                    >
                      {name}
                    </text>
                  </g>
                )}
                {showHubCities && city && (
                  <g transform="translate(0, 20)">
                    <g transform="translate(0, 0)">
                      {image}
                      <text
                        x={20}
                        y={12}
                        style={{
                          fontSize: "10px",
                          fill: "#555",
                          fontFamily: "Inter",
                        }}
                      >
                        {city}
                      </text>
                    </g>
                  </g>
                )}
              </g>
            </Marker>
          ))}
        </ComposableMap>
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          justifyContent={"space-between"}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <Switch
              checked={showHubCities}
              onChange={() => setShowHubCities(!showHubCities)}
              color="primary"
            />
            <Typography fontSize={"16px"} color="#344054" fontWeight={600}>
              Show Hub Cities
            </Typography>
          </div>

          <Tooltip
            title={legendContent}
            arrow
            placement="top"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
            }}
            sx={{
              "& .MuiTooltip-tooltip": {
                backgroundColor: "#FFF", // Change background color
                color: "white", // Optional: Change text color
                fontSize: "14px", // Optional: Change font size
                padding: "10px", // Optional: Change padding
              },
            }}
          >
            <div>
              <CommonButton
                variant="outlined"
                fontWeight={600}
                borderRadius={"20px"}
                fontSize={"12px"}
                value="Legend"
                startIcon={<AlertCircleIco />}
              />
            </div>
          </Tooltip>
        </Box>
      </Paper>
    </Box>
  );
};

export default CandidateProximityInsight;
